export default __webpack_public_path__ + "static/media/6.53493820.png";